import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AdminLayout from "../../components/admin/AdminLayout";
import { usePortalAuth } from "../../lib/portalAuth";
import { OW_API } from "../../lib/operatorWalk";
import AdminOverview from "../../components/ow/AdminOverview";
import AdminClients from "../../components/ow/AdminClients";
import AdminReports from "../../components/ow/AdminReports";

const TITLES = {
  overview: { t: "Operator Walk Overview", s: "Client health, reminders due, and latest scores." },
  clients: { t: "Operator Walk Clients", s: "Manage clients, locations, and client logins." },
  reports: { t: "Operator Walk Reports", s: "Create, publish, and manage monthly reports." },
};

export default function AdminOperatorWalkPage() {
  const { authHeader } = usePortalAuth();
  const { pathname } = useLocation();
  const view = pathname.endsWith("/clients")
    ? "clients"
    : pathname.endsWith("/reports")
    ? "reports"
    : "overview";

  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  const loadClients = useCallback(async () => {
    setLoadingClients(true);
    try {
      const res = await axios.get(`${OW_API}/admin/ow/clients`, { headers: authHeader });
      setClients(res.data.clients || []);
    } catch {
      setClients([]);
    } finally {
      setLoadingClients(false);
    }
  }, [authHeader]);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  const onDataChanged = () => {
    loadClients();
    setRefreshKey((k) => k + 1);
  };

  return (
    <AdminLayout title={TITLES[view].t} subtitle={TITLES[view].s}>
      {loadingClients && view !== "overview" ? (
        <div className="py-16 flex items-center justify-center text-ink-muted">
          <Loader2 className="w-5 h-5 animate-spin mr-2" /> Loading
        </div>
      ) : (
        <>
          {view === "overview" && <AdminOverview refreshKey={refreshKey} />}
          {view === "clients" && <AdminClients clients={clients} onChanged={onDataChanged} />}
          {view === "reports" && <AdminReports clients={clients} onChanged={onDataChanged} />}
        </>
      )}
    </AdminLayout>
  );
}
